import { useDevice } from "@lookiero/aurora";

const useExtendedScreen = () => {
  const { screen } = useDevice();

  if (screen.width >= 1280) {
    return { ...screen, L: false, XL: true };
  }

  return { ...screen, XL: false };
};

export { useExtendedScreen };
